export const CLAIM_GET_ALL = 'CLAIM_GET_ALL'
export const CLAIM_GET_ALL_SUCCESS = 'CLAIM_GET_ALL_SUCCESS'
export const CLAIM_GET_ALL_ERROR = 'CLAIM_GET_ALL_ERROR'
export const CLAIMS_BY_TASK_ID = 'CLAIMS_BY_TASK_ID'
export const GET_CLAIM_CATEGORIES = 'GET_CLAIM_CATEGORIES'
export const CLAIM_CATEGORIES_GET_ALL_SUCCESS =
  'CLAIM_CATEGORIES_GET_ALL_SUCCESS'
export const CLAIM_CATEGORIES_GET_ALL_ERROR = 'CLAIM_CATEGORIES_GET_ALL_ERROR'
export const CLAIM_GET_BY_ID = 'CLAIM_GET_BY_ID'
